import { AfterViewInit, Component, NgZone} from '@angular/core';
import { environment } from '@env/environment';
import { AccessibilityObserverService } from '@core/service/accessibility-observer.service';
import { take } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  constructor(
    private accessibilityObserverService: AccessibilityObserverService,
    private ngZone: NgZone
  ) { }

  ngAfterViewInit(): void {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      this.accessibilityObserverService.start();
    });
  }

  redirectToPortal(): void {
    window.location.href = environment.loginHomePage;
  }
}
